<script>
export default {
    created() {
        this.$cache.createCache('courses', 'courses/') 
    },
    data() {
        return {          
          
        }
    
        },
        computed: {
            courses() {  return this.$store.state.courses == null ? [] : this.$store.state.courses; }
        }
}
</script>
<template>
    <div v-fade-in>
        <main class="opacity-white-bg">
            <section>
                <h2>{{this.$store.state.settings.Course.plural}}</h2>
                <div class="Courses-wrapper">
                    <div v-for="course in courses" class="Courses-course-item"> 
                        <div @mouseover="course.hovered = true" @mouseout="course.hovered = false" :class="blurOut(course) ? 'ImageGallery-grayscale' : 'ImageGallery-no-grayscale'" >
                            <div class="position-relative">
                                <div class="Courses-course-img-area">
                                    <img v-if="course.image_id" :src="url + 'uploads/'+ publicPage.customer_id+'/images/thumbnails/'+ course.image_name" />  
                                    <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                                </div>
                                <h4 :style="{'background-color': getColor('background_color') }">{{ course.name }}</h4>
                            </div>
                            <div class="Courses-course-max-booking">
                                <i><span v-html="course.description.slice(0, 100) + '...'"></span></i>
                                <div class="margin-top-15">Max antal deltagare: {{ course.max_number_of_participents }} <span style="color: red" v-if="course.max_number_of_participents - course.number_of_approved_participants <= course.show_few_left_at_this_number">Fåtal platser kvar!</span></div>
                                <div>Pris: <b>{{ course.price }} kr</b></div>
                                <div>Kursstart: {{ course.course_start }}</div>
                                <div>Antal tillfällen: {{ course.number_of_occations }} st </div>
                                
                                <button class="Courses-btn float-right margin-top-15" :style="{'background-color': getColor('background_color') }" @click="goTopage(course)">Läs mer</button>
                            </div>
                        </div>              
                    </div>    
                </div>
            </section>
        </main>
    </div>
</template>
<style scoped>
    
</style>